export default {
  subscriptions: [],
  subscription: {},
  filters: {},
  paginationOptions: {},
  apiResource: 'subscriptions'
};
